var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLowCarb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71299 6.74064V11.6016L3.71299 10.6016V6.47364C3.71399 5.97064 2.80899 5.78764 2.84899 5.32264C2.78499 3.05464 8.03398 2.35064 11.036 3.27964L11.836 2.47964C8.33799 1.14964 1.72699 1.97964 1.84899 5.32164C1.84899 5.69464 2.00599 6.22764 2.71299 6.74064ZM15.246 1.88064L14.547 1.18164L0.853985 14.8746L0.845985 14.8666L0.790985 14.9216L1.49799 15.6286L3.33599 13.7906C3.54999 13.9296 3.80299 14.0116 4.07599 14.0116H11.843C12.594 14.0116 13.205 13.4006 13.205 12.6486V6.73964C13.911 6.22764 14.068 5.69464 14.068 5.32164C14.068 4.82864 13.946 4.20664 13.497 3.62864L15.245 1.88064H15.246ZM12.444 6.04564C12.296 6.13664 12.205 6.29864 12.205 6.47264V12.6496C12.205 12.8496 12.043 13.0126 11.843 13.0126H4.11399L12.771 4.35564C13.142 4.97164 13.292 5.58764 12.444 6.04564Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLowCarb);
export default __webpack_public_path__ + "static/media/ico_low_carb.ac50d28c8df8a04c06f1363297992778.svg";
export { ForwardRef as ReactComponent };